var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';

// eslint-disable-next-line max-statements
const adjustShade = (hexValue, percent, lighten) => {
  if (!hexValue) return '';
  const hex = hexValue.replace('#', '');
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const factor = percent / 100;

  const adjust = (channel) =>
  lighten ? Math.round(channel + (255 - channel) * factor) : Math.round(channel * (1 - factor));

  const newR = adjust(r);
  const newG = adjust(g);
  const newB = adjust(b);

  return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`;
};

const getDarkerShade = (hexValue, percent = 60) =>
adjustShade(hexValue, percent, false);

const getLighterShade = (hexValue, percent = 60) =>
adjustShade(hexValue, percent, true);

const DisplayPill = ({
  children,
  color,
  className




}) => {
  const bgColor = color ? getLighterShade(color) : '#f3f4f6';
  const textColor = color ? getDarkerShade(color) : '#111827';
  const style = { backgroundColor: bgColor, color: textColor };
  return (/*#__PURE__*/
    _jsx("span", {
      className: `${className !== null && className !== void 0 ? className : 'py-1 px-2.5 rounded-md text-xs block font-medium'}`,
      style: style,
      "data-testid": "pill-comp" }, void 0,

    children
    ));

};

export { DisplayPill };